import React from "react";
import { RCCButton, RCCGrid, RCCInput, RCCTooltip } from "react-common-components";
import LovParameterField from "src/components/Lov/ParameterField";
import Select from "src/components/Select";
import Title from "src/components/Title";
import { useTranslation } from "src/context/Translations/context";
import { IPatba003 } from "../../config/interface";
import { IParameterNode } from "../interface";

const ParameterNode: React.FC<IParameterNode> = ({
	parameter,
	register,
	errors,
	control,
	setValue
}) => {
	const { translate} = useTranslation();

	const returnOptionsDefault = (defaultValue?:String,options?:IPatba003[]) => {
		const option = options?.find((x) => x.paa003Valor=== defaultValue);
		if (option)
			return {value:option.paa003Valor,label:option.paa003Descricao};
		return undefined;
	};
    
	const returnInputs = () => {
		if(parameter.paa002Tipo.toString() === "1"){
			return (
				<RCCGrid container
					wrap="nowrap"
					alignItems="baseline"
				>		
					<Select
						control={control}
						label=""
						name={`parameter-${parameter.paa002Id}`}
						defaultValue={returnOptionsDefault(parameter.parameterValue||parameter.paa002Valordefault,parameter.options)}
						error={errors[`parameter-${parameter.paa002Id}`]}
						options={
							parameter.options?.map((opt:any) => ({value:opt.paa003Valor,label:opt.paa003Descricao}))||[]
						}
						submit="value and label"
						styleInline="height: 32px; min-height: 32px; min-width: 57px;"	
					/>
					<RCCTooltip
						text={translate("Inserir valor default")}
						color="purple"
						position="left"
					>
						<RCCButton
							icon={{name: "starFilled",color:"var(--purple)"}}
							color="transparent"
							onClick={() => 
								setValue(`parameter-${parameter.paa002Id}`,returnOptionsDefault(parameter.paa002Valordefault,parameter.options))							
							}
						/>
					</RCCTooltip>
				</RCCGrid>
			);
		}
		if(parameter.paa002Sqllov){
			return(
				<RCCGrid container 
					wrap="nowrap"
					alignItems="baseline"
				>		
					<LovParameterField
						control={control}
						label=""
						name={`parameter-${parameter.paa002Id}`}
						defaultValue={parameter.parameterValue||parameter.paa002Valordefault}
						extraParametersOnLoad={{
							ParameterId: parameter.paa002Id
						}}
						error={errors[`parameter-${parameter.paa002Id}`]}
						submit="value and label"
						styleInline="height: 32px; min-height: 32px; min-width: 57px;"	
					/>
					<RCCTooltip
						text={translate("Inserir valor default")}
						color="purple"
						position="left"
					>
						<RCCButton
							icon={{name: "starFilled",color:"var(--purple)"}}
							color="transparent"
							onClick={() => 
								setValue(`parameter-${parameter.paa002Id}`,returnOptionsDefault(parameter.paa002Valordefault,parameter.options))
							}
						/>
					</RCCTooltip>
				</RCCGrid>
			);
		}
		return(
			<RCCGrid container
				wrap="nowrap"
				alignItems="baseline"
			>		
				<RCCInput
					name={`parameter-${parameter.paa002Id}`}
					register={register}
					label=""
					defaultValue={parameter.parameterValue||parameter.paa002Valordefault}
					error={errors[`parameter-${parameter.paa002Id}`]}
					styleInline="height: 32px; min-height: 32px; min-width: 57px;"	
				/>					
				<RCCTooltip
					text={translate("Inserir valor default")}
					color="purple"
					position="left"
				>
					<RCCButton
						icon={{name: "starFilled",color:"var(--purple)"}}
						color="transparent"
						onClick={() => setValue(`parameter-${parameter.paa002Id}`,parameter.paa002Valordefault)}
					/>
				</RCCTooltip>
			</RCCGrid>
		);
		
	};

	return (
		<RCCGrid container item 
			justifyContent="space-between" 
			alignContent="center"
			alignItems="center"
		>
			<RCCGrid item xs={7} sm={8} md={9}style={{whiteSpace:"normal"}}> 
				<Title color="defaultColor" size="sm">
					{`${parameter.paa002Parametro} - ${translate(parameter.paa002Descricao)}`}
				</Title>
				{parameter.paa002Explicacao &&
					<Title color="grey" size="xs" >
						{translate(parameter.paa002Explicacao)}
					</Title>
				}
			</RCCGrid>
			<RCCGrid container item justifyContent="flex-end" xs={5} sm={4} md={3}>
				{returnInputs()}
			</RCCGrid>
		</RCCGrid>
	);

};

export default ParameterNode;
